import React, { useEffect, useRef } from "react";
import { PROCESS } from "../mock";

export default function Process() {
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in-view")),
      { threshold: 0.15 }
    );
    ref.current?.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="proceso" ref={ref} className="relative py-24 md:py-36" style={{ background: "#00101f" }}>
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <p className="reveal uppercase tracking-[0.35em] text-[12px] mb-4" style={{ color: "#e55b36" }}>{PROCESS.eyebrow}</p>
        <h2 className="reveal font-display font-semibold text-white text-[40px] md:text-[64px] leading-none mb-16">{PROCESS.heading}</h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PROCESS.steps.map((s) => (
            <div key={s.num} className="reveal group relative rounded-2xl p-7 transition-all duration-300 hover:-translate-y-1" style={{ background: "#001d3f", border: "1px solid rgba(177,205,255,0.12)" }}>
              <div className="font-display font-semibold text-[46px] leading-none" style={{ color: "#e55b36" }}>{s.num}</div>
              <h3 className="font-display font-medium text-white text-[24px] mt-4">{s.name}</h3>
              <p className="mt-3 text-[15px] leading-relaxed" style={{ color: "#b1cdff" }}>{s.desc}</p>
              <div className="mt-6 h-[3px] w-10 transition-all duration-300 group-hover:w-20" style={{ background: "#e55b36" }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
